import { Question } from 'survey-core'

export const CUSTOM_TYPE = 'surveyprioritycomponent'

export class PriorityDisplay extends Question {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
    this.isRequired = false
    this.value = 'displayed'
  }

  getType (): string {
    return CUSTOM_TYPE
  }

  get priorityLevel (): number {
    return this.getPropertyValue('priorityLevel') ?? 1
  }

  set priorityLevel (val: number) {
    this.setPropertyValue('priorityLevel', val)
  }
}
